// Floor detail — leaf route. Areas live as an inline panel under
// FloorDetailPage; no separate area-detail route since the backend
// has no GET-by-id for areas.

import { createFileRoute } from "@tanstack/react-router";

import { FloorDetailPage } from "../features/floors/FloorDetailPage";

export const Route = createFileRoute(
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/floors/$floorSlug",
)({
  component: FloorDetailRoute,
});

function FloorDetailRoute() {
  const { accountSlug, tenantSlug, siteSlug, floorSlug } = Route.useParams();
  return (
    <FloorDetailPage
      accountSlug={accountSlug}
      tenantSlug={tenantSlug}
      siteSlug={siteSlug}
      floorSlug={floorSlug}
    />
  );
}
